// Faz 8.6 / Batch A1 — leave status → badge tone (single source of truth).
//
// One map, every consumer imports it (dashboard pending-approvals card + the
// request-center list) — SSOT rule: fixing a tone here propagates everywhere.
// Tones follow the novem mockup pill language (requests.jsx StatusPill):
// pending decision = warning (apricot), approved = success (emerald),
// rejected = danger, draft/cancelled = neutral, taken = info.

import type { BadgeTone } from "@novemai/components";

export const LEAVE_STATUS_TONE: Readonly<Record<string, BadgeTone>> = {
  submitted: "warning",
  approved: "success",
  rejected: "danger",
  cancelled: "neutral",
  draft: "neutral",
  taken: "info",
};

/**
 * The status a request is SHOWN as. `taken` exists in the status enum but
 * nothing moves an approved request there once its days have passed, so a
 * leave from last month would read "Onaylandı" forever. From the day after its
 * last day, an approved request displays as taken.
 *
 * Display-only on purpose: the stored status, the status filter tabs and every
 * server-side rule keep seeing `approved` — the same request must not change
 * meaning depending on which screen asks. The dashboard's "approved" KPI and
 * status distribution count this shown status too, so they agree with the list.
 * "Today" is the browser's local date,
 * the only clock the client has; the tenant timezone is not exposed to it.
 */
export function displayLeaveStatus(
  row: { readonly status: string; readonly end_date: string },
  now: Date = new Date(),
): string {
  if (row.status !== "approved") return row.status;
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const today = `${String(now.getFullYear())}-${month}-${day}`;
  return row.end_date < today ? "taken" : row.status;
}
